import React from "react";
import { View, StyleSheet, FlatList } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import Logger from "../../../common/utils/Logger";
import { useMobile } from "../../../hooks/useMobile";

function NtMobileFeatureSection(props) {
  const isMobile = useMobile();
  const data = [
    {
      icon: "router-wireless",
      title: "use your ezLINQ phone number & service",
    },
    {
      icon: "cellphone",
      title: "Free App to App calling",
    },
    {
      icon: "deskphone",
      title: "Free app to ezLINQ calling",
    },
    {
      icon: "account-group",
      title: "Free conference calling",
    },
    {
      icon: "web",
      title: "Online CONNECT portal",
    },
    {
      icon: "headset",
      title: "Free 411 directory",
    },
    {
      icon: "sync",
      title: "Auto contact sync",
    },
    {
      icon: "web-box",
      title: "Buy international TALK Credits",
    },
    {
      icon: "room-service",
      title: "24 x 7 x 365 customer support",
    },
    {
      icon: "microphone-variant",
      title: "All new Voice Engine",
    },
    {
      icon: "battery-charging-50",
      title: "Reduced Battery Consumption",
    },
    {
      icon: "monitor-eye",
      title: "Improved User Interface",
    },
    {
      icon: "webhook",
      title: "Improved contact Management",
    },
    {
      icon: "apple-ios",
      title: "Integration with Apple iOS Callkit",
    },
    {
      icon: "voicemail",
      title: "Visual Voicemail with Transcripts",
    },
    {
      icon: "tools",
      title: "Setup & manage the ezLINQ",
    },
  ];

  const renderRow = ({ item }) => {
    return (
      <View
        style={{
          borderRadius: 10,
          backgroundColor: "#181818",
          width: 159,
          height: 120,
          alignItems: "center",
          padding: 15,
          marginRight: 10,
        }}
      >
        <NtMaterialIcon
          containerStyle={{}}
          size={34}
          name={item.icon}
          color="#12ABFF"
        />
        <NtText
          style={{
            marginTop: 10,
            fontSize: 12,
            fontWeight: "500",
            color: "white",
            textAlign: "center",
          }}
        >
          {item.title}
        </NtText>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <NtSectionTitle>FEATURES</NtSectionTitle>
      <NtSectionDescription style={{ textAlign: "center", marginTop: 8 }}>
        Have a NT Connect ezLINQ? Use your ezLINQ number while on-the-go. Just
        like using your regular home phone to call anyone.
      </NtSectionDescription>

      <View style={{ marginTop: 40 }}>
        <FlatList
          key={isMobile}
          data={data}
          renderItem={(item) => renderRow(item)}
          keyExtractor={(item) => item.title}
          ItemSeparatorComponent={() => <View style={{ height: 10 }} />}
          numColumns={isMobile ? 2 : 4}
          // numColumns={4}
          columnWrapperStyle={{ justifyContent: "center" }}
        />
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtMobileFeatureSection;
